<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <map-nav-bar :btmList="btmList" :pz="isFold ? 'left-zl' : ''" />
    <div id="map" class="map"></div>
    <div
      class="map-btn"
      :style="!isFold ? 'right: 27%' : 'right: 10px;top:105px'"
      @click="changeGdMap"
      v-if="!isGdMap"
    >
      返 回
    </div>
    <div
      class="zd-btn"
      :class="{ foldBtn: !isFold, unfoldBtn: isFold }"
      @click="changeFold"
    >
      <img src="~images/granary/zl/arrow.png" />
    </div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import cDetail from "../util/zzdhDetail";
// import { findIndexByName } from "@/util/index";
import { getScreenV2ByIndexIdGetLayer } from "@/api/granary";
// import { zlMixin } from "@/util/mixin/zlMixin";
import { snqyMixin } from "@/util/mixin/snqyMixin";
import mmsData from "../util/mms-geo.json";

export default {
  mixins: [snqyMixin],
  components: {
    cDetail,
  },
  data() {
    return {
      isGdMap: true,
      curIndex: 0, //当前加载分布类型id
      curName: "", //当前加载分布名称
      nowZoom: 2,
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      hoverArr: [],
      baseList: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [-10, 50],
      baseAnchor: [13, 36],
      mianArr: [],
      nycy: [
        {
          name: "荔枝",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_lz_02/MapServer",
        },
        {
          name: "龙眼",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_ly_01/MapServer",
        },
        {
          name: "香蕉",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_xj_01/MapServer",
        },
      ],
      ycypsfzPointList: [],
      ycypzyzPointList: [],
      cyqzPointList: [],
      nygyPointList: [],
      lysfzPointList: [],
      // btmList: [
      //   {
      //     name: "国家级一村一品示范镇",
      //     pic: require("images/map/yelxx.png")
      //   },
      //   {
      //     name: "广东省“一村一品、一镇一业”专业镇",
      //     pic: require("images/map/yelxx.png")
      //   },
      //   {
      //     name: "产业强镇",
      //     pic: require("images/map/yelxx.png")
      //   },
      //   {
      //     name: "广东省农业公园",
      //     pic: require("images/map/yelxx.png")
      //   },
      //   {
      //     name: "省级休闲农业与乡村旅游示范镇",
      //     pic: require("images/map/yelxx.png")
      //   }
      // ]
      isFold: false, //左右两侧是否折叠 默认展开
    };
  },
  computed: {
    ...mapGetters(["granaryIndex"]),
    btmList() {
      if (this.isGdMap) {
        return [];
      } else {
        return [
          {
            name: "国家级一村一品示范镇",
            pic: require("images/granary/zl/ycypsfz.png"),
          },
          {
            name: "广东省“一村一品、一镇一业”专业镇",
            pic: require("images/granary/zl/ycypzyz.png"),
          },
          {
            name: "产业强镇",
            pic: require("images/granary/zl/cyqz.png"),
          },
          {
            name: "广东省农业公园",
            pic: require("images/granary/zl/nygy.png"),
          },
          {
            name: "省级休闲农业与乡村旅游示范镇",
            pic: require("images/granary/zl/xclysfz.png"),
          },
        ];
      }
    },
    // btmList() {
    //   let arr = [
    //     // {
    //     //   name: "“菜篮子”基地",
    //     //   pic: require("images/granary/clz.png")
    //     // },
    //     // {
    //     //   name: "“一村一品”示范镇",
    //     //   pic: require("images/granary/ycyp.png")
    //     // }
    //   ];
    //   let tmparr;
    //   switch (this.curIndex) {
    //     case -1:
    //       break;
    //     case 0:
    //       tmparr = [
    //         {
    //           name: "面积>40万亩",
    //           pic: require("images/map/red.jpg")
    //         },
    //         {
    //           name: "面积>1万亩",
    //           pic: require("images/map/fs.jpg")
    //         },
    //         {
    //           name: "面积>1000亩",
    //           pic: require("images/map/dfs.jpg")
    //         },
    //         {
    //           name: "示范果园",
    //           pic: require("images/map/sfgy.png")
    //         },
    //         {
    //           name: "种植大户",
    //           pic: require("images/map/zzdh.png")
    //         },
    //         {
    //           name: "贡园",
    //           pic: require("images/map/gy2.png")
    //         }
    //       ];
    //       arr = tmparr.concat(arr);
    //       break;
    //     case 1:
    //       tmparr = [
    //         {
    //           name: "高州市龙眼现代化农业产业园",
    //           pic: require("images/map/ry-c1.jpg")
    //         },
    //         {
    //           name: "面积>1万亩",
    //           pic: require("images/map/ry-c2.jpg")
    //         },
    //         {
    //           name: "面积>1000亩",
    //           pic: require("images/map/ry-c3.jpg")
    //         },
    //         {
    //           name: "示范果园",
    //           pic: require("images/map/sfgy.png")
    //         },
    //         {
    //           name: "种植大户",
    //           pic: require("images/map/zzdh.png")
    //         },
    //         {
    //           name: "贡园",
    //           pic: require("images/map/gy2.png")
    //         }
    //       ];
    //       arr = tmparr.concat(arr);
    //       break;
    //     case 2:
    //       tmparr = [
    //         {
    //           name: "香蕉面积>1万亩",
    //           pic: require("images/map/xj-c1.jpg")
    //         },
    //         {
    //           name: "香蕉面积>1000亩",
    //           pic: require("images/map/xj-c2.jpg")
    //         },
    //         {
    //           name: "三华李面积>1万亩",
    //           pic: require("images/map/xj-c3.jpg")
    //         },
    //         {
    //           name: "三华李面积>1000亩",
    //           pic: require("images/map/xj-c4.jpg")
    //         },
    //         {
    //           name: "香蕉、三华李面积>1万亩",
    //           pic: require("images/map/xj-c5.jpg")
    //         },
    //         {
    //           name: "示范果园",
    //           pic: require("images/map/sfgy.png")
    //         },
    //         {
    //           name: "种植大户",
    //           pic: require("images/map/zzdh.png")
    //         },
    //         {
    //           name: "贡园",
    //           pic: require("images/map/gy2.png")
    //         }
    //       ];
    //       arr = tmparr.concat(arr);
    //       break;
    //   }
    //   return arr;
    // }
  },
  mounted() {
    /* this.$bus.$on("zlchange", val => {
      let index = findIndexByName(val, this.nycy);
      this.poisiton = {};
      this.curName = val;
      this.curIndex = index;
      if (index > -1) {
        // change map2
        if (this.tileMapUrl === this.$config.tileMapUrlColor) {
          this.initMap(true, true);
        }
        if (this.basesGroup) {
          this.map.removeLayer(this.basesGroup);
        }
        if (index > 0) {
          this.clearzlMaps();
        }
        this.changeMap(this.nycy[index]["url"]);
      } else {
        this.removemap2();
        setTimeout(() => {
          if (this.tileMapUrl !== this.$config.tileMapUrlColor) {
            this.initMap(false, true);
          }
          if (val === "“一村一品”示范镇") {
            this.dataLoad(1);
          } else if (val === "“菜篮子”基地") {
            this.dataLoad(2);
          } else if (val === "龙头企业") {
            this.snqyDataload(3);
          } else if (val === "合作社") {
            this.snqyDataload(4);
          } else if (val === "家庭农场") {
            this.snqyDataload(5);
          } else if (val === "农资经营企业") {
            if (this.ditu) {
              this.map.removeLayer(this.ditu);
              this.ditu = null;
            }
            this.snqyDataload(6);
          } else if (val === "生产基地") {
            this.snqyDataload(7);
          }
        }, 10);
      }
    }); */
    this.initMap();
  },
  methods: {
    changeMap(url) {
      // 修改切片图层
      this.removemap2();
      if (url) {
        this.tileMapLayer2 = esri.tiledMapLayer({
          url: url,
        });
        window.map.addLayer(this.tileMapLayer2);
        if (this.curIndex === 0) {
          //   this.zlpointLoad();
        }
      }
    },
    removemap2() {
      // 删除切片图层
      if (this.tileMapLayer2) {
        this.tileMapLayer2._container.remove();
        this.tileMapLayer2.remove();
        this.tileMapLayer2 = null;
      }
    },
    changeGdMap() {
      this.isGdMap = true;
      this.initMap(true, true); //传true 重新加载地图
      if (this.isFold) {
        //如果是折叠状态
        this.changeFold();
      }
    },
    changeFold() {
      if (!this.isFold) {
        //如果是展开状态
        this.$store.dispatch("drawer/setLeftComponent", null);
        this.$store.dispatch("drawer/setRightComponent", null);
      } else {
        this.$store.dispatch("drawer/setLeftComponent", "leftDrawer");
        this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
      }
      this.isFold = !this.isFold;
      this.$bus.$emit("foldchange", this.isFold);
    },
    initMap(isgd = true, isreload = false) {
      // 加载底图
      // this.tileMapUrl = this.$config.tileMapUrl;
      this.nowZoom = 2;
      this.tileMapUrl =
        window.__config.VUE_APP_MAP_URL +
        "/rest/services/440900/gd_mm_03/MapServer";
      let resolutions = [
        0.010986328125000003,
        0.009613332983215593,
        0.008240339962822913,
        0.0068673469424302335,
      ];
      let lat = 22.683073442301463,
        lng = 113.20013254464811;
      if (!isgd) {
        this.tileMapUrl =
          window.__config.VUE_APP_MAP_URL +
          "/rest/services/440900/mm_ny_02/MapServer";
        resolutions = this.$config.resolutions;
        lat = this.$config.sLat;
        lng = this.$config.sLng;
        this.nowZoom = 0;
      }
      if (isreload && this.map) {
        this.map.off("click");
        this.map.off("zoom");
        this.map.off("move");
        this.map.remove();
        this.map = null;
        window.map = null;
      }
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: resolutions,
          origin: [-400.0, 399.9999999999998],
        }
      );

      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false,
      });
      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: this.tileMapUrl,
      });
      tileMapLayer.addTo(map);
      this.map.setView(L.latLng(lat, lng), this.nowZoom);
      //   setTimeout(() => {
      // eslint-disable-next-line no-undef
      // $(".leaflet-control-attribution").empty();
      //   }, 300);
      //   if (this.tileMapUrl === this.$config.tileMapUrl) {
      //     this.changeMap(this.nycy[this.curIndex]["url"]);
      //   }
      if (isgd) {
        this.geoloadmms();
      }

      if (!isgd) {
        this.dataLoad2();
        this.ycypsfzLoad();
        this.ycypzyzLoad();
        this.cyqzLoad();
        this.nygyLoad();
        this.lysfzLoad();
        // 画线示例
        var latlngs = [
          [21.791139862122407, 111.03089156965474],
          [21.780747029755275, 110.9541539522167],
          [21.75607640306407, 110.91608257612343],
          [21.74924539280039, 110.83815522818247],
          [21.71316332768555, 110.86849335600681],
          [21.626955681667937, 110.84588847645142],
        ];

        //画折线
        this.polyline = L.polyline(latlngs, {
          color: "#00a85b",
          weight: 6,
          opacity: 0.7,
          lineJoin: "round",
        }).addTo(map);

        //画圆点
        this.dotGroup = new L.layerGroup();
        latlngs.forEach((e) => {
          L.circle(e, {
            color: "#f08519",
            fillColor: "#f08519",
            radius: 500,
            fillOpacity: 1,
          }).addTo(this.dotGroup);
        });
        this.map.addLayer(this.dotGroup);
      }
      map.on("click", (e) => {
        console.log(e.latlng);
        this.poisiton = {};
      });
      map.on("zoom", () => {
        this.nowZoom = this.map.getZoom();
        console.log("zoom", this.nowZoom);
        this.poisiton = {};
        if (!isgd) {
          this.dataLoad2();
        }
      });
      map.on("move", () => {
        this.poisiton = {};
      });
    },
    geoloadmms() {
      this.ditu = L.geoJSON(mmsData, {
        style: function() {
          return {
            color: "#FF0000",
            fillOpacity: 0.000000000000001,
            weight: 0,
            //   dashArray: "10"
          };
        },
        onEachFeature: (feature, layer) => {
          console.log("feature", feature);
          layer.on({
            click: () => {
              this.isGdMap = false;
              this.initMap(false, true);
              if (!this.isFold) {
                //如果是展开状态
                this.changeFold();
              }
            },
          });
        },
      });
      this.ditu.addTo(this.map);
    },
    //加载 “一村一品”示范镇 点数据
    dataLoad(mode = 1) {
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
        this.baseList = [];
      }
      if (mode === 1) {
        getScreenV2ByIndexIdGetLayer("afb536119a404882a1ed60ac5443aff5").then(
          (data) => {
            // if (this.basesGroup) {
            //   this.map.removeLayer(this.basesGroup);
            //   this.baseList = [];
            // }
            // data.data.unshift({
            //   img: "granary_lt.png",
            //   code: "0201",
            //   tc_request_url: "1",
            //   latitude: "22.15301368697925",
            //   tc_color: null,
            //   tc_pic: "granary_lt",
            //   tc_name: "龙头企业",
            //   type: "point",
            //   tc_template: "companyDrawer",
            //   tc_status: 2,
            //   grade: 3,
            //   name: "龙头企业",
            //   tc_type: "point",
            //   tc_id: "79ac212440584f5fb2d1e2f166a5afdb",
            //   tc_quote_template: "companyDrawer",
            //   config: null,
            //   desc:
            //     '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">产业园核心区位于电白区，是园区荔枝产业发展的一产、二产、三产核心所在地，代表了园区发展的核心驱动力，汇集了整个规划区及全县的资金、技术、人才等资源要素，是整个核心区乃至全县现代生猪农业发展的先驱板块。核心区以科技创新为动力，进一步加强与有关科研构的有机对接和合作，围绕现代农业全产业链转型发展科技需求，搭建省级及以上荔枝产业科技创新平台，推进产学研深度结合，建设成集科技创新、成果孵化、技术展示、质量追溯、大数据应用等功能于一体的科技创新载体，展示农业新技术、新产品和新模式，促进智慧农业、健康农业、休闲农业等新业态发展。</span></p>',
            //   longitude: "110.97497423601772"
            // });
            data.data.map((ele) => {
              ele.latitude = Number(ele.latitude);
              this.baseList.push(ele);
            });
            this.baseLoad();
          }
        );
      } else if (mode === 2) {
        getScreenV2ByIndexIdGetLayer("4d029dd658b24143a2b5a9a7f37f760c").then(
          (data) => {
            data.data.map((ele) => {
              ele.latitude = Number(ele.latitude);
              this.baseList.push(ele);
            });
            this.baseLoad("clz.png", false);
          }
        );
      }
    },
    //两区数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        let areaLayer = L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: this.areaList[i],
        }).addTo(this.map);
        let lineUrl = require("images/index/map/line_map.png");
        let pointUrl = require("images/index/map/point.png");
        let myIcons = L.divIcon({
          html:
            "<div id='indicator-box'><div style='display:flex'><img src='" +
            pointUrl +
            "' /></div><div style='top:-20px;left:9px'><img src='" +
            lineUrl +
            "'/><span class='my-div-names'>" +
            this.areaList[i].name +
            "</span ></div></div>",
          className: "my-div-icon",
          iconAnchor: [-10, 0],
        });
        let areaPointLayer = L.marker([areaArr[i].lat, areaArr[i].lng], {
          icon: myIcons,
          attributes: this.areaList[i],
        }).addTo(this.map);
        this.mianArr.push(areaPointLayer);
        areaLayer.on("click", (e) => {
          this.$store.dispatch(
            "drawer/setGraphic",
            e.sourceTarget.options.attributes
          );
          this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
        });
        areaLayer.on("mouseover", (it) => {
          this.ncCode = it.target.options.attributes.code;
        });
        areaLayer.on("mouseout", (it) => {
          this.ncCode = it.target.options.attributes.code;
          // this.deleHover(it);
        });
        areaPointLayer.on("click", (e) => {
          this.$store.dispatch(
            "drawer/setGraphic",
            e.sourceTarget.options.attributes
          );
          this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
        });
        areaPointLayer.on("mouseover", (it) => {
          this.ncCode = it.target.options.attributes.code;
        });
      }
    },
    //科技中心数据加载
    pointLoad() {
      this.pointList.map((it) => {
        if (this.pointLayer) {
          this.map.removeLayer(this.pointLayer);
        }
        console.log("科技中心数据加载");
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;

          let pointUrl = require("images/map/" + it.tc_pic + ".png");
          let pointIcon = L.divIcon({
            html:
              "<div class='indicator-box'><img style='width:35px' src='" +
              pointUrl +
              "' /><span class='my-div-names lt'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.pointAnchor,
          });

          this.pointLayer = L.marker([it.lat, it.lng], {
            icon: pointIcon,
            attributes: it,
          }).addTo(this.map);
          this.pointLayer.on("click", (e) => {
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
          this.pointLayer.on("mouseover", (it) => {
            this.ncCode = it.target.options.attributes.code;
          });
        }
      });
    },
    //基地数据加载
    baseLoad(img = "ycyp.png", hasclick = true) {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      let pointUrl = require("images/map/" + img);
      this.baseList.map((it) => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          //   let pointUrl = require("images/map/" + it.img);
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor,
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          if (hasclick) {
            baseLayer.on("click", (e) => {
              console.log("data ==", e.sourceTarget.options.attributes);
              const data = e.sourceTarget.options.attributes;
              if (data.tc_pic) {
                this.$bus.$emit("ImageViewer", [
                  window.__config.VUE_APP_IMG_URL + data.tc_pic,
                ]);
              }
              // this.$store.dispatch(
              //   "drawer/setGraphic",
              //   e.sourceTarget.options.attributes
              // );
              // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
            });
          }
          //   baseLayer.on("mouseover", it => {
          //     this.ncCode = it.target.options.attributes.code;
          //   });
        }
      });
      this.map.addLayer(this.basesGroup);
      //   L.marker([22.15301368697925, 110.97497423601772]).addTo(this.map);
    },

    //基地数据加载, 默认hide
    /* baseLoad_h(img = "ycyp.png", hasclick = true) {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      let pointUrl = require("images/map/" + img);
      this.baseList.map(it => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          //   let pointUrl = require("images/map/" + it.img);
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names hide'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          if (hasclick) {
            baseLayer.on("click", e => {
              console.log("data ==", e.sourceTarget.options.attributes);
              const data = e.sourceTarget.options.attributes;
              if (data.tc_pic) {
                this.$bus.$emit("ImageViewer", [
                  window.__config.VUE_APP_IMG_URL + data.tc_pic
                ]);
              }
              // this.$store.dispatch(
              //   "drawer/setGraphic",
              //   e.sourceTarget.options.attributes
              // );
              // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
            });
          }
          baseLayer.on("mouseover", it => {
            console.log("it", it.target.options.attributes);
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", it => {
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
      //   L.marker([22.15301368697925, 110.97497423601772]).addTo(this.map);
    } */

    //加载标记点+折线框数据
    dataLoad2() {
      let data = {
        code: 200,
        data: [
          {
            name:
              "化州市化橘红产业园（范围：平定镇、中垌镇、官桥镇、丽岗镇以及石湾、河西街道）",
            town: "中垌镇",
            latitude: "21.795198347867085",
            longitude: "110.42531874367091",
            lineClassName: "line1",
            nameClassName: "name1",
            // img: "bluexx",
          },
          {
            name: "茂南区“好心湖畔”田园综合体：金塘镇、山阁镇",
            town: "金塘镇",
            latitude: "21.736883044020203",
            longitude: "110.80127358259212",
            lineClassName: "line2",
            nameClassName: "name2",
            // img: "bluexx",
          },
          {
            name: "茂南区罗非鱼产业园（范围：金塘镇、公馆镇、山阁镇、新坡镇）",
            town: "公馆镇",
            latitude: "21.658341636097646",
            longitude: "110.76796112851049",
            lineClassName: "line3",
            nameClassName: "name3",
            // img: "bluexx",
          },
          {
            name:
              "高州市龙眼产业园（范围：镇江镇、沙田镇、荷塘镇、石仔岭街道办、宝光街道办）",
            town: "镇江镇",
            latitude: "21.874932571159775",
            longitude: "110.68467999330643",
            lineClassName: "line4",
            nameClassName: "name4",
            // img: "bluexx",
          },
          {
            name: "中国美丽休闲乡村“八坊村”",
            town: "镇隆镇",
            latitude: "22.23311377553813",
            longitude: "110.80246331309502",
            lineClassName: "line5",
            nameClassName: "name5",
            // img: "bluexx",
          },
          {
            name:
              "信宜市三华李产业园（范围：钱排镇、茶山镇、洪冠镇、白石镇和平塘镇）",
            town: "钱排镇",
            latitude: "22.42229772089047",
            longitude: "111.24266359917362",
            lineClassName: "line6",
            nameClassName: "name6",
            // img: "bluexx",
          },
          {
            name: "茂名市荔枝国家现代农业产业园（范围：根子等11个镇）",
            town: "根子镇",
            latitude: "21.817803227422473",
            longitude: "111.07372186775967",
            lineClassName: "line7",
            nameClassName: "name7",
            // img: "bluexx",
          },
          {
            name: "广东茂名国家农业科技园区（范围：根子等11个镇）",
            town: "根子镇",
            latitude: "21.817803227422473",
            longitude: "111.07372186775967",
            lineClassName: "line8",
            nameClassName: "name8",
            // img: "bluexx",
          },
          {
            name: "高州大唐荔乡田园综合体（范围：根子镇）",
            town: "根子镇",
            latitude: "21.817803227422473",
            longitude: "111.07372186775967",
            lineClassName: "line9",
            nameClassName: "name9",
            // img: "bluexx",
          },
          {
            name: "高州市荔枝产业园（范围：根子镇、分界镇）",
            town: "根子镇",
            latitude: "21.817803227422473",
            longitude: "111.07372186775967",
            lineClassName: "line10",
            nameClassName: "name10",
            // img: "bluexx",
          },
          {
            name:
              "茂名市荔枝优势产区产业园（范围：根子镇、分界镇、泗水镇、谢鸡镇、金山街道，电白区霞洞镇、林头镇、旦场镇、坡心镇、七迳镇、水东街道和茂南区羊角镇、山阁镇）",
            town: "根子镇",
            latitude: "21.817803227422473",
            longitude: "111.07372186775967",
            lineClassName: "line11",
            nameClassName: "name11",
            // img: "bluexx",
          },
          {
            name:
              "电白区沉香产业园（范围：沙琅镇、观珠镇、马踏镇、林头镇和水东镇）",
            town: "根子镇",
            latitude: "21.817803227422473",
            longitude: "111.07372186775967",
            lineClassName: "line12",
            nameClassName: "name12",
            // img: "bluexx",
          },
          {
            name:
              "电白区对虾产业园（范围：岭门镇、博贺镇、七迳镇、沙院镇、南海街道、电海街道）",
            town: "博贺镇",
            latitude: "21.481174791456056",
            longitude: "111.20756654933763",
            lineClassName: "line13",
            nameClassName: "name13",
            // img: "bluexx",
          },
          {
            name:
              "电白区对虾产业园（范围：岭门镇、博贺镇、七迳镇、沙院镇、南海街道、电海街道）",
            town: "岭门镇",
            latitude: "21.540540492631123",
            longitude: "111.34973934443593",
            lineClassName: "line14",
            nameClassName: "name14",
            // img: "bluexx",
          },
          {
            name: "茂名市乡村振兴“精彩100里”",
            town: "镇盛镇",
            latitude: "21.626955681667937",
            longitude: "110.84588847645142",
            lineClassName: "line15",
            nameClassName: "name15",
            // img: "bluexx",
          },
        ],
      };

      data.data.forEach((ele) => {
        this.pointList.push(ele);
      });

      this.pointLoad2();
    },

    pointLoad2() {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      this.pointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          if (it.lineClassName === "line14") {
            let lineClassName2 = "";
            //nowZoom 缩放层级0-3
            switch (this.nowZoom) {
              case 1:
                lineClassName2 = "nopx-line14_1";
                break;
              case 2:
                lineClassName2 = "nopx-line14_2";
                break;
              case 3:
                lineClassName2 = "nopx-line14_3";
                break;
              default:
                lineClassName2 = "";
            }
            myIcons = L.divIcon({
              html:
                "<div class='indicator-box'>" +
                "<div class='ny-div-point'></div><div class='ny-div-line nopx-" +
                it.lineClassName +
                " " +
                lineClassName2 +
                "'></div><div class='nopx-ny-div-name nopx-" +
                it.nameClassName +
                "'>" +
                it.name +
                "</div></div>",
              className: "ztgh-div-icon",
              iconAnchor: [10, 10],
            });
          } else {
            myIcons = L.divIcon({
              html:
                "<div class='indicator-box'>" +
                "<div class='ny-div-point'></div><div class='ny-div-line nopx-" +
                it.lineClassName +
                "'></div><div class='nopx-ny-div-name nopx-" +
                it.nameClassName +
                "'>" +
                it.name +
                "</div></div>",
              className: "ztgh-div-icon",
              iconAnchor: [10, 10],
            });
          }
          //   }
          //    else {
          //     myIcons = L.divIcon({
          //       html:
          //         "<div class='indicator-box ico_sf'><div style='display:flex'><img src='" +
          //         pointUrl +
          //         "' /></div><div class='ztgh-div-" +
          //         it.tc_leftRight +
          //         "'><img class='Img" +
          //         it.tc_leftRight +
          //         "' src='" +
          //         lineUrl +
          //         "'/><span class='ztgh-div-names'>" +
          //         it.name +
          //         "</span ></div></div>",
          //       className: "ztgh-div-icon",
          //       iconAnchor: this.djd
          //     });
          //   }

          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.basesGroup);
          baseLayer.on("click", (e) => {
            //
            console.log(e);
            // debugger;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
    },

    //加载国家级一村一品示范镇数据
    ycypsfzLoad() {
      let data = {
        code: 200,
        data: [
          {
            name: "沙琅镇（祥寿龟鳖)",
            town: "沙琅镇",
            latitude: "21.777383753141237",
            longitude: "111.17187463425017",
            tc_pic: "ico_sf",
          },
        ],
      };

      data.data.forEach((ele) => {
        this.ycypsfzPointList.push(ele);
      });

      this.ycypsfzPointLoad();
    },
    //国家级一村一品示范镇点加载
    ycypsfzPointLoad() {
      // this.jdArr = [];
      if (this.ycypsfzGroup) {
        this.map.removeLayer(this.ycypsfzGroup);
      }
      this.ycypsfzGroup = new L.layerGroup();
      this.ycypsfzPointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/granary/zl/ycypsfz.png");
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });

          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.ycypsfzGroup);
          baseLayer.on("click", (e) => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.ycypsfzGroup);
    },

    //加载"广东省“一村一品、一镇一业”专业镇数据
    ycypzyzLoad() {
      let data = {
        code: 200,
        data: [
          {
            name: "茂南区公馆镇（罗非鱼）",
            town: "公馆镇",
            latitude: "21.689972837480752",
            longitude: "110.76082274549299",
            tc_pic: "ico_sf",
          },
        ],
      };

      data.data.forEach((ele) => {
        this.ycypzyzPointList.push(ele);
      });

      this.ycypzyzPointLoad();
    },
    //广东省“一村一品、一镇一业”专业镇点加载
    ycypzyzPointLoad() {
      // this.jdArr = [];
      if (this.ycypzyzGroup) {
        this.map.removeLayer(this.ycypzyzGroup);
      }
      this.ycypzyzGroup = new L.layerGroup();
      this.ycypzyzPointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/granary/zl/ycypzyz.png");
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });

          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.ycypzyzGroup);
          baseLayer.on("click", (e) => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.ycypzyzGroup);
    },

    //加载产业强镇数据
    cyqzLoad() {
      let data = {
        code: 200,
        data: [
          {
            name: "高州市根子镇（荔枝）",
            town: "根子镇",
            latitude: "21.826822522607817",
            longitude: "111.02256345613432",
            tc_pic: "ico_sf",
          },
        ],
      };

      data.data.forEach((ele) => {
        this.cyqzPointList.push(ele);
      });

      this.cyqzPointLoad();
    },
    //产业强镇点加载
    cyqzPointLoad() {
      // this.jdArr = [];
      if (this.cyqzGroup) {
        this.map.removeLayer(this.cyqzGroup);
      }
      this.cyqzGroup = new L.layerGroup();
      this.cyqzPointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/granary/zl/cyqz.png");
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });

          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.cyqzGroup);
          baseLayer.on("click", (e) => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.cyqzGroup);
    },

    //加载广东省农业公园数据
    nygyLoad() {
      let data = {
        code: 200,
        data: [
          {
            name: "广垦国家热带农业公园（4A）",
            town: "石湾街道",
            latitude: "21.67143621241661",
            longitude: "110.49908203485165",
            tc_pic: "ico_sf",
          },
        ],
      };

      data.data.forEach((ele) => {
        this.nygyPointList.push(ele);
      });

      this.nygyPointLoad();
    },
    //广东省农业公园点加载
    nygyPointLoad() {
      // this.jdArr = [];
      if (this.nygyGroup) {
        this.map.removeLayer(this.nygyGroup);
      }
      this.nygyGroup = new L.layerGroup();
      this.nygyPointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/granary/zl/nygy.png");
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });

          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.nygyGroup);
          baseLayer.on("click", (e) => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.nygyGroup);
    },

    //加载乡村旅游示范镇数据
    lysfzLoad() {
      let data = {
        code: 200,
        data: [
          {
            name: "信宜市钱排镇",
            town: "钱排镇",
            latitude: "22.33414386634638",
            longitude: "111.26764793973479",
            tc_pic: "ico_sf",
          },
        ],
      };

      data.data.forEach((ele) => {
        this.lysfzPointList.push(ele);
      });

      this.lysfzPointLoad();
    },
    //乡村旅游示范镇点加载
    lysfzPointLoad() {
      // this.jdArr = [];
      if (this.lysfzGroup) {
        this.map.removeLayer(this.lysfzGroup);
      }
      this.lysfzGroup = new L.layerGroup();
      this.lysfzPointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          let pointUrl = require("images/granary/zl/xclysfz.png");
          // let pointUrl = require("images/map/" + it.img + ".png");
          //   let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          //   if (it.tc_pic === "ico_sf") {
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
              it.tc_pic +
              "' src='" +
              pointUrl +
              "'/></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [16, 8],
          });

          let baseLayer = L.marker([it.latitude, it.longitude], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.lysfzGroup);
          baseLayer.on("click", (e) => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.lysfzGroup);
    },
  },

  //   destroyed() {
  //     this.$bus.$off("zlchange");
  //   }
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9
    >>>.leaflet-bar
        display none

    >>>.leaflet-bottom
        display none

    .ncDetail
        position absolute

    >>>
        .my-div-icon
            color #fff

        .indicator-box
            position relative

        .my-div-name
            font-size .08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, .8)
            padding 2px 8px

        .my-div-name:hover
            z-index 999
            font-size .09rem

        .my-div-names.hide
            display none
        .my-div-names
            z-index 999
            font-size .07rem
            color #4DB5FE
            position absolute
            top -36px
            left 13px
            width max-content
            padding .01rem .06rem
            border-radius 5px
            border 1px solid #4DB5FE
            background #011C46
            transform translateX(-50%)
            &:before
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -10px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #4DB5FE;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
            &:after
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -9px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #011C46;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
        .my-div-names.lt
            background #FF9000
            &:before
                border-top-color #FF9000
        .zhu-div-icon
            color #fff
        .indicator-box
            position relative
        .indicator-box:hover
            z-index 1000
        .zhu-div-text
            position absolute
            height 30px
            display flex
            justify-content center
            align-items center
            width 0.72rem
        .sLine
            transform translate(28%, -67%)
        .zhu-div-box
            display flex
            justify-content center
            align-items center
            flex-wrap wrap
        .zhu-div-image
            width 31px
        .zhu-div-name
            top -30px
            text-align center
        .zhus-div-name.hide
            display none
        .zhus-div-name
            z-index 9
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            padding 2px 10px
            white-space nowrap
        .yellow
            background-color rgba(0, 126, 120, 0.8)
        .nopx-left-btm
            position absolute
            left -120px
            top 17px
        .nopx-left-top
            position absolute
            left: -138px;
            top: -50px;
        .nopx-right-top
            position absolute
            left 14px
            top -19px
        .nopx-right-btm
            position absolute
            left: 14px;
            top: 18px;
        .nopx-right-top-box
            position absolute
            left 144px
            transform: translateY(-50%);
        .nopx-right-btm-box
            position absolute
            left 120px
            bottom -150px
        .nopx-left-top-box
            position absolute
            left -64px
            transform: translateX(-100%);
            top: -178px;
        .nopx-left-btm-box
            position absolute
            left: -105px;
            transform: translateX(-100%);
            bottom: -115px;
        .nopx-pic1
            position absolute
            top -50px
        .ny-div-point
            width 10px
            height 10px
            background transparent
        .ny-div-line
            position absolute
            // top 5px
            // left 5px
            width 0
            height 0
            border 1px dashed #5e5e5e
            z-index 1
        .nopx-ny-div-name
            position absolute
            // bottom 0
            // left 50%
            // transform translate(-50%, 100%)
            width 230px
            padding 10px
            font-size 12px
            font-weight bold
            color #000
            text-align center
            background #fff
            border-radius 15px
            z-index 2
        .nopx-line1
            width 82px
            transform rotate(33deg)
            top -19px
            left -74px
        .nopx-name1
            top -70px
            right 80px
            background #ef8642
        .nopx-line2
            width 270px
            transform rotate(-6deg)
            top 17px
            left -268px
        .nopx-name2
            top 2px
            left -518px
            background #b8cedb
        .nopx-line3
            width 226px
            transform rotate(-20deg)
            top 42px
            right 1px
        .nopx-name3
            top 57px
            right 223px
            background #a0d9f6
        .nopx-line4
            width 230px
            transform rotate(73deg)
            top -108px
            right -74px
        .nopx-name4
            top -247px
            right 77px
            width 260px
            color #fff
            background #5fa777
        .nopx-line5
            width 140px
            transform rotate(46deg)
            top -48px
            right -14px
        .nopx-name5
            top -122px
            right 107px
            width 200px
            color #e62128
            border 2px solid #994346
            border-radius 10px
        .nopx-line6
            width 145px
            transform rotate(-60deg)
            top -60px
            left -33px
        .nopx-name6
            top -153px
            left 78px
            width 233px
            background #d1cde6
        .nopx-line7
            width 250px
            transform rotate(-35deg)
            top -70px
            left -20px
        .nopx-name7
            top -162px
            left 211px
            width 330px
            background #e6212a
            color #fff
        .nopx-line8
            width 224px
            transform rotate(-24deg)
            top -43px
            left -7px
        .nopx-name8
            top -107px
            left 211px
            width 330px
            background #acce22
        .nopx-line9
            width 279px
            transform rotate(-8deg)
            top -17px
            left 1px
        .nopx-name9
            top -53px
            left 281px
            width 260px
            background #e95a6e
        .nopx-line9
            width 279px
            transform rotate(-8deg)
            top -17px
            left 1px
        .nopx-name9
            top -53px
            left 281px
            width 260px
            background #e95a6e
        .nopx-line10
            width 276px
            transform rotate(3deg)
            top 11px
            left 3px
        .nopx-name10
            top 1px
            left 281px
            width 260px
            background #ee8780
        .nopx-line11
            width 293px
            transform rotate(20deg)
            top 54px
            left -6px
        .nopx-name11
            top 60px
            left 281px
            width 260px
            background #ef8762
        .nopx-line12
            width 343px
            transform rotate(37deg)
            top 108px
            left -30px
        .nopx-name12
            top 185px
            left 281px
            width 260px
            background #af8384
        .nopx-line13
            width 150px
            transform rotate(46deg)
            top 56px
            left -20px
        .nopx-name13
            top 82px
            left 110px
            width 260px
            background #56a9b7
        .nopx-line14
            width 143px
            transform rotate(78deg)
            top 73px
            left -53px
        .nopx-line14_1
            // width 181px
            // transform rotate(98deg)
            // top 94px
            // left -100px
        .nopx-line14_2
            width 179px
            top 91px
            left -67px
        .nopx-line14_3
            width 302px
            transform rotate(115deg)
            top 141px
            left -212px
        .nopx-name14
            top 171px
            left 133px
            width 260px
            background #56a9b7
            display none
        .nopx-line15
            width 208px
            transform rotate(137deg)
            top 81px
            left -170px
        .nopx-name15
            top 133px
            right 153px
            width 185px
            color #e62128
            border 2px solid #994346
            border-radius 10px
        .sLine
            // transform translate(-110%, -50%)
        .ztgh-div-image
            position relative
            width 0.1rem
            height 0.1rem
        .ico_sf
            width 0.2rem
            height 0.2rem
.map-btn
  position absolute
  top 24%
  right 27%
  z-index 10000
  padding 8px 14px
  font-size 14px
  color #fff
  border-radius 4px
  border 1px solid #00b1cf
  background-color rgba(1,30,47,0.8)
  box-shadow inset 0 0 10px #00b1cf
  cursor pointer
  transition .3s

.zd-btn
  position absolute
  top 50%
  transform translateY(-50%)
  z-index 10000
  padding 5px
  background rgba(1,22,76,0.4)
  cursor pointer
  transition .5s

.foldBtn
  right calc(26% + 5px)
  animation bounce-left1 1s linear infinite
  transform rotate(180deg)

.unfoldBtn
  right 5px
  animation bounce-left2 1s linear infinite

@keyframes bounce-left1
  0%
    right calc(26% + 6px)
  50%
    right calc(26% + 9px)
  100%
    right calc(26% + 6px)

@keyframes bounce-left2
  0%
    right 6px
  50%
    right 9px
  100%
    right 6px
</style>
